import { createStore, applyMiddleware, compose, Store, AnyAction } from 'redux';
import reduxThunk from 'redux-thunk';
import { persistStore } from 'redux-persist';

import reducers, { ApplicationState } from './reducers';

export type StoreType = Store<ApplicationState, AnyAction>;

function multi({ dispatch }: any) {
    return (next: any) => (action: any) => Array.isArray(action) ? action.filter(Boolean).map(dispatch) : next(action);
}

const middlewares = [
    reduxThunk,
    multi,
];

// @ts-ignore
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const enhancer = composeEnhancers(applyMiddleware(...middlewares));

export default function configureStore(persistedState = {}) {

    const store = createStore(
        reducers,
        persistedState,
        enhancer,
    );

    const persistor = persistStore(store);
    return { persistor, store };
}



// WEBPACK FOOTER //
// ./src/configureStore.ts